import { Link } from 'react-router-dom';
import { allProjectsData } from '../../constants/data';
import useTranslate from '../../hooks/useTranslate';
export default function ServiceProjects({ ids }) {
  const { translate } = useTranslate();
  return <div className="service-project-grid">{ids.map(id => {
    const project = allProjectsData.find(p => p.projectName === id);
    if (!project) return null;
    const cover = Array.isArray(project.src) ? project.src[0]?.src || project.src[0] : project.src;
    const titleKey = id === 'yon-therapy' ? 'service.project.ion' : id === 'mom' ? 'service.project.mom' : project.title;
    return <Link key={id} to={`/projects${project.link}/${id}`}><img src={cover} alt="" loading="lazy" /><h3>{translate(titleKey)}</h3></Link>;
  })}</div>;
}
